import React, { useEffect, useRef, useState } from "react";
import { Loading } from "@kitbird/core";
import { StickyTable } from "../../../../../components/Table/Table.style";
import Table from "../../../../../components/Table";
import useReportReceiptSubmission from "../../useReportReceiptSubmission";
import columns from "../../columns";

interface ReportReceiptSubmissionTableI {
  useCustomHook: ReturnType<typeof useReportReceiptSubmission>,
}
export default function ReportReceiptSubmissionTable({
  useCustomHook,
}: ReportReceiptSubmissionTableI) {
  const obsRef = useRef(null);
  const tableRef = useRef(document.createElement("table"));
  const {
    meta,
    params,
    setParams,
    hiddenColumn,
    trxReportList,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    setModalConfig,
  } = useCustomHook;

  const options = {
    root: obsRef.current,
    rootMargin: "0px",
    threshold: [0],
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({
      isIntersecting,
    }) => {
      if (isIntersecting) {
        fetchNextPage();
      }
    });
  }, options);

  useEffect(() => {
    if (meta.page === meta.total_pages) observer.unobserve(obsRef.current || document.createElement("tfoot"));
    else observer.observe(obsRef.current || document.createElement("tfoot"));
  }, [meta]);

  return (
    <StickyTable ref={tableRef}>
      {isFetching && !isFetchingNextPage
        ? <Loading variant="line" />
        : <Table
          withNumber
          dataSource={trxReportList}
          columns={columns(useCustomHook)}
          footer={
            <>
              <tfoot ref={obsRef} style={{ height: 5, width: "100%" }} />
            </>
          }
          hiddenColumnKeys={hiddenColumn}
          sortConfig={{
            sortBy: params.sortBy,
            sortType: params.sortType,
            onSort: (sortBy, sortType) => setParams((curr) => ({ ...curr, sortBy, sortType })),
          }}
          onClickRow={(row) => setModalConfig({ id: row.trx_id, extendBm: row.extend_bm, type: "DETAIL" })}
        />
      }
    </StickyTable>
  );
}
